// File: config.navbar.js
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: Configuration used by cgp-nav-bar.
// Other Contributors:

// Nav Bar Items


export const phfNavItems = {
    id: 'PHF',
    title: 'PHF',
    iconClass: 'fa fa-fw fa-bar-chart-o',
    expanded: true,
    children: [
        {
            id: 'PHF/Administration',
            title: 'Administration',
            iconClass: 'fa fa-fw',
            children: [
                {
                    id: 'PHF/Administration/Users',
                    title: 'Users',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'PHF/Administration/Program',
                    title: 'Program',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'PHF/Administration/Plant',
                    title: 'Plant',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'PHF/Administration/Press',
                    title: 'Press',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'PHF/Administration/Distribution-method',
                    title: 'Dist. Method',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'PHF/Administration/Die-Family',
                    title: 'Die Family',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'PHF/Administration/Part-Type',
                    title: 'Part Type',
                    iconClass: 'fa fa-fw',
                },
                {
                    id: 'PHF/Administration/Upload',
                    title: 'Upload',
                    iconClass: 'fa fa-fw',
                },
            ]
        },
        {
            id: 'PHF/Parts',
            title: 'Part List',
            iconClass: 'fa fa-fw',
        }
    ]
}

export const navItems = [phfNavItems];

// Nav Bar Actions
//
export const navActions = {};
